module.exports = __webpack_public_path__ + "static/image/history/pc/201605.ver2_0_2.jpg?56cd439f";